import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";

const EditarCoordenador = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { parametros } = useCliente();
  const clienteId = localStorage.getItem("cliente_id");

  const [coordenador, setCoordenador] = useState({
    nome_completo: "",
    cpf: "",
    genero: "",
    data_nascimento: "",
    cargo: "",
    telefone: "",
    email: "",
    usuario: ""
  });

  const [erros, setErros] = useState({});

  useEffect(() => {
    axios.get(`/api/usuarios/${id}`)
      .then((res) => setCoordenador(res.data))
      .catch((err) => {
        console.error(err);
        alert("Erro ao carregar os dados do coordenador.");
      });
  }, [id]);

  const limparMascara = (valor) => valor.replace(/\D/g, "");

  const aplicarMascaraCpf = (valor) => {
    const v = limparMascara(valor);
    return v.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, "$1.$2.$3-$4").substring(0, 14);
  };

  const aplicarMascaraTelefone = (valor) => {
    const v = limparMascara(valor);
    if (v.length <= 10) {
      return v.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3").substring(0, 14);
    } else {
      return v.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3").substring(0, 15);
    }
  };

  const validarCPF = (cpf) => {
    cpf = limparMascara(cpf);
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
    let soma = 0, resto;
    for (let i = 1; i <= 9; i++) soma += parseInt(cpf[i - 1]) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf[9])) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(cpf[i - 1]) * (12 - i);
    resto = (soma * 10) % 11;
    return resto === parseInt(cpf[10]);
  };



  const verificarCpfDuplicado = async (cpfInformado) => {
    try {
      const response = await axios.get("/api/usuarios", {
        params: { cpf: cpfInformado, cliente_id: clienteId }
      });
  
      if (response.data.length > 0) {
        const outroUsuario = response.data.find(u => u.id !== parseInt(id));
        if (outroUsuario) {
          setErros(prev => ({ ...prev, cpf: "CPF já cadastrado para outro usuário." }));
          return true; // CPF duplicado
        }
      }
      setErros(prev => ({ ...prev, cpf: "" }));
      return false; // CPF não duplicado
    } catch (error) {
      console.error("Erro ao verificar CPF duplicado:", error);
      return false;
    }
  };
  
  

  const validarCampo = (name, value) => {
    let mensagem = "";

    if (name === "cpf") {
      if (!validarCPF(value)) mensagem = "CPF inválido ou incompleto.";
    }

    if (name === "nome_completo") {
      if (!value || value.trim().length < 3) mensagem = "Nome obrigatório com pelo menos 3 letras.";
    }

    if (name === "email") {
      const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (!emailValido) mensagem = "Informe um e-mail válido.";
    }

    if (name === "usuario") {
      if (!value || value.trim().length < 3) mensagem = "Usuário obrigatório com pelo menos 3 letras.";
    }

    if (name === "telefone") {
      const telLimpo = limparMascara(value);
      if (value && telLimpo.length < 10) mensagem = "Telefone incompleto ou inválido.";
    }

    if (name === "data_nascimento") {
      if (!value) {
        mensagem = "Data de nascimento obrigatória.";
      } else {
        const hoje = new Date();
        const nascimento = new Date(value);
        const ano1900 = new Date("1900-01-01");

        if (nascimento > hoje || nascimento < ano1900 || isNaN(nascimento.getTime())) {
          mensagem = "Data de nascimento inválida.";
        }
      }
    }

    setErros((prev) => ({ ...prev, [name]: mensagem }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    let valorAtualizado = value;

    if (name === "cpf") {
      valorAtualizado = aplicarMascaraCpf(value);
    } else if (name === "telefone") {
      valorAtualizado = aplicarMascaraTelefone(value);
    }

    setCoordenador((prev) => ({ ...prev, [name]: valorAtualizado }));
    validarCampo(name, valorAtualizado);
    if (name === "cpf" && validarCPF(valorAtualizado)) {
        await verificarCpfDuplicado(limparMascara(valorAtualizado));
      }
      
  };

  const validarTodos = () => {
    const campos = ["cpf", "nome_completo", "email", "usuario", "telefone", "data_nascimento"];
    campos.forEach((campo) => validarCampo(campo, coordenador[campo]));
  
    const existemErros = Object.values(erros).some((e) => e);
    return !existemErros;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const cpfDuplicado = await verificarCpfDuplicado(limparMascara(coordenador.cpf));
    
    if (cpfDuplicado) {
      alert("Corrija o CPF antes de salvar.");
      return;
    }
  
    if (!validarTodos()) return;
  
    try {
      await axios.put(`/api/usuarios/${id}`, {
        ...coordenador,
        cpf: limparMascara(coordenador.cpf),
        telefone: limparMascara(coordenador.telefone || ""),
        tipo: "coordenador",
        cliente_id: clienteId,
        usuario_id: parseInt(localStorage.getItem("user_id"), 10)
      });
  
      alert("Coordenador atualizado com sucesso.");
      navigate("/coordenadores");
    } catch (error) {
      console.error(error);
      alert("Erro ao atualizar coordenador.");
    }
  };
  


  return (
    <div className="form-wrapper form-coordenador">
      <h2 className="form-title">Editar Coordenador</h2>

      <form onSubmit={handleSubmit} noValidate>
        {/* Linhas de campos */}
        {/* CPF + Nome */}
        <div className="form-row">
          <div className="form-group campo-cpf" style={{ width: "160px", flex: "none" }}>
            <label>CPF</label>
            <input
              type="text"
              name="cpf"
              value={coordenador.cpf}
              onChange={handleChange}
            />
            {erros.cpf && <small className="campo-obrigatorio">{erros.cpf}</small>}
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Nome Completo</label>
            <input
              type="text"
              name="nome_completo"
              value={coordenador.nome_completo}
              onChange={handleChange}
            />
            {erros.nome_completo && <small className="campo-obrigatorio">{erros.nome_completo}</small>}
          </div>
        </div>

        {/* Gênero + Data de nascimento + Cargo */}
        <div className="form-row">
          <div className="form-group campo-genero" style={{ width: "210px", flex: "none" }}>
            <label>Gênero</label>
            <select name="genero" value={coordenador.genero} onChange={handleChange}>
              <option value="">Selecione</option>
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
              <option value="Outro">Outro</option>
            </select>
          </div>
          <div className="form-group campo-data" style={{ width: "160px", flex: "none" }}>
            <label>Data de Nascimento</label>
            <input
              type="date"
              name="data_nascimento"
              value={coordenador.data_nascimento || ""}
              onChange={handleChange}
            />
            {erros.data_nascimento && <small className="campo-obrigatorio">{erros.data_nascimento}</small>}
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Cargo</label>
            <input
              type="text"
              name="cargo"
              value={coordenador.cargo}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Telefone + Email */}
        <div className="form-row">
          <div className="form-group campo-telefone" style={{ width: "180px", flex: "none" }}>
            <label>Telefone</label>
            <input
              type="text"
              name="telefone"
              value={coordenador.telefone || ""}
              onChange={handleChange}
            />
            {erros.telefone && <small className="campo-obrigatorio">{erros.telefone}</small>}
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={coordenador.email}
              onChange={handleChange}
            />
            {erros.email && <small className="campo-obrigatorio">{erros.email}</small>}
          </div>
        </div>

        {/* Usuário + Tipo */}
        <div className="form-row">
          <div className="form-group campo-usuario" style={{ width: "220px", flex: "none" }}>
            <label>Usuário</label>
            <input
              type="text"
              name="usuario"
              value={coordenador.usuario}
              onChange={handleChange}
            />
            {erros.usuario && <small className="campo-obrigatorio">{erros.usuario}</small>}
          </div>
          <div className="form-group campo-tipo" style={{ width: "220px", flex: "none" }}>
            <label>Tipo de Usuário</label>
            <input type="text" value="Coordenador" disabled />
          </div>
        </div>

        {/* Botões */}
        <div className="form-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate("/coordenadores")}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditarCoordenador;

